<template>
  <transition name="cookie-fade">
    <div v-if="isOpen" class="cookie-settings-wrapper">
      <div class="cookie-settings-header">
        <h2 class="cookie-settings-title">Управление cookie</h2>
        <button type="button" class="close-btn" @click="closeAndReturn">
          <ico name="icoClose" color="#A5D8FF" />
        </button>
      </div>

      <div class="cookie-settings-body">
        <div class="text-block">
          <p class="description-text">
            Выберите, какие категории cookie могут использоваться на сайте
            Bytorg. Необходимые cookie обеспечивают базовую работу сервиса и
            активны всегда. Аналитические cookie включаются только с вашего
            согласия.
          </p>
          <router-link :to="cookiePath" target="_blank" class="policy-link">
            Политика обработки файлов cookie
          </router-link>
        </div>

        <div class="cookie-option-card">
          <div class="card-header">
            <span class="option-title">Необходимые</span>
            <span class="option-status">Всегда включено</span>
          </div>
          <p class="card-text">
            Нужны для входа в аккаунт, безопасности, сохранения настроек и
            корректной работы основных функций сайта.
          </p>
        </div>

        <div class="cookie-option-card">
          <div class="card-header">
            <span class="option-title">Аналитические</span>
            <label class="switch">
              <input type="checkbox" v-model="analyticsEnabled" />
              <span class="slider round"></span>
            </label>
          </div>
          <p class="card-text">
            Помогают анализировать использование сервиса, оценивать посещаемость
            и улучшать пользовательские сценарии. Для веб-аналитики могут
            использоваться Яндекс.Метрика, Google Analytics и др.
          </p>
        </div>

        <div class="cookie-settings-actions">
          <button class="btn btn-primary" @click="acceptAll">
            Принять всё
          </button>
          <button class="btn btn-outline" @click="saveSelection">
            Сохранить выбор
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { cookiePath } from "@/router/cookie";
import { applyCookieConsent } from "@/utils/cookieConsent";

export default {
  name: "CookieSettings",
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      cookiePath,
      analyticsEnabled: true,
    };
  },
  created() {
    const savedConsent = localStorage.getItem("cookie_consent");
    if (savedConsent === "necessary") {
      this.analyticsEnabled = false;
    }
  },
  methods: {
    closeAndReturn() {
      this.$emit("close-and-return");
    },
    acceptAll() {
      this.analyticsEnabled = true;
      localStorage.setItem("cookie_consent", "all");
      applyCookieConsent();
      this.$emit("saved");
    },
    saveSelection() {
      const consentValue = this.analyticsEnabled ? "all" : "necessary";

      localStorage.setItem("cookie_consent", consentValue);

      if (consentValue === "necessary") {
        window.location.reload();
        return;
      }

      applyCookieConsent();
      this.$emit("saved");
    },
  },
};
</script>

<style lang="less" scoped>
.cookie-settings-wrapper {
  position: fixed;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 100;

  width: 680px;
  max-width: calc(100% - 32px);
  padding: 32px 32px 44px 32px;

  background: #484e55;
  border-radius: 10px;
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.08),
    0 12px 40px rgba(0, 0, 0, 0.35);
  box-sizing: border-box;

  display: flex;
  flex-direction: column;

  .cookie-settings-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 32px;

    .cookie-settings-title {
      margin: 0;
      font-family: Montserrat, sans-serif;
      font-weight: 600;
      font-size: 32px;
      line-height: 100%;
      color: #ffffff;
    }

    .close-btn {
      background: transparent;
      border: none;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0;
      width: 24px;
      height: 24px;
    }
  }

  .cookie-settings-body {
    display: flex;
    flex-direction: column;
    gap: 32px;
    flex: 1;

    .text-block {
      display: flex;
      flex-direction: column;
      gap: 16px;

      .description-text {
        margin: 0;
        font-family: Montserrat, sans-serif;
        font-weight: 500;
        font-size: 16px;
        line-height: 100%;
        color: #ffffff;
      }

      .policy-link {
        font-family: Montserrat, sans-serif;
        font-weight: 500;
        font-size: 16px;
        line-height: 100%;
        text-decoration: underline;
        color: #a5d8ff;

        &:hover {
          text-decoration: none;
        }
      }
    }

    .cookie-option-card {
      display: flex;
      flex-direction: column;
      gap: 16px;
      padding: 16px;
      border: 1px solid #7b9ab1;
      border-radius: 8px;
      background: transparent;
      box-sizing: border-box;

      .card-header {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .option-title {
          font-family: Montserrat, sans-serif;
          font-weight: 600;
          font-size: 18px;
          line-height: 100%;
          color: #ffffff;
        }

        .option-status {
          font-family: Montserrat, sans-serif;
          font-weight: 500;
          font-size: 14px;
          line-height: 100%;
          color: #fede09;
        }
      }

      .card-text {
        margin: 0;
        font-family: Montserrat, sans-serif;
        font-weight: 500;
        font-size: 16px;
        line-height: 100%;
        color: #ffffff;
      }
    }

    .switch {
      position: relative;
      display: inline-block;
      width: 44px;
      height: 24px;

      input {
        opacity: 0;
        width: 0;
        height: 0;

        &:checked + .slider {
          background-color: #a5d8ff;
        }

        &:checked + .slider:before {
          transform: translateX(20px);
          background-color: #ffffff;
        }
      }

      .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #2f353c;
        transition: 0.3s;
        border-radius: 12px;

        &:before {
          position: absolute;
          content: "";
          height: 20px;
          width: 20px;
          left: 2px;
          top: 2px;
          background-color: #ffffff;
          transition: 0.3s;
          border-radius: 99.88px;
        }
      }
    }

    .cookie-settings-actions {
      display: flex;
      align-items: center;
      gap: 16px;

      .btn {
        flex: 1;
        height: 60px;
        border-radius: 10px;
        font-family: Montserrat, sans-serif;
        font-weight: 600;
        font-size: 16px;
        line-height: 100%;
        text-align: center;
        cursor: pointer;
        box-sizing: border-box;
        transition: opacity 0.2s;

        &:hover {
          opacity: 0.9;
        }

        &-primary {
          background: #a5d8ff;
          color: #000000;
          border: none;
        }

        &-outline {
          background: transparent;
          border: 2px solid #a5d8ff;
          color: #a5d8ff;
        }
      }
    }
  }

  @media (max-width: 1439px) {
    width: 524px;
    max-width: calc(100% - 32px);
    padding: 32px 24px;

    .cookie-settings-header {
      .cookie-settings-title {
        font-size: 28px;
      }
    }

    .cookie-settings-body {
      .text-block {
        .description-text,
        .policy-link {
          font-size: 14px;
        }
      }

      .cookie-option-card {
        .card-header {
          .option-title {
            font-size: 16px;
          }

          .option-status {
            font-size: 14px;
          }
        }

        .card-text {
          font-size: 14px;
        }
      }

      .cookie-settings-actions {
        flex-direction: column;
        align-items: center;

        .btn {
          flex: initial;
          width: 100%;
          font-size: 14px;
        }
      }
    }
  }

  @media (max-width: 767px) {
    width: 316px;
    padding: 28px 16px;

    .cookie-settings-header {
      .cookie-settings-title {
        font-size: 24px;
      }
    }

    .cookie-settings-body {
      .text-block {
        .description-text,
        .policy-link {
          font-size: 14px;
        }
      }

      .cookie-option-card {
        .card-header {
          .option-title {
            font-size: 16px;
          }

          .option-status {
            font-size: 10px;
          }
        }

        .card-text {
          font-size: 14px;
        }
      }

      .cookie-settings-actions {
        .btn {
          width: 100%;
          height: 52px;
          font-size: 14px;
        }
      }
    }
  }
}

.cookie-fade-enter-active,
.cookie-fade-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.cookie-fade-enter,
.cookie-fade-leave-to {
  opacity: 0;
  transform: translate(-50%, 20px);
}
</style>
